/**
 * @file comingUp.ts
 * @brief Pure rules for Home's "Coming up" (calm Home, DES 19-10-2026): which
 *        calendar meetings show and how their people read.
 *
 * Related: ./ComingUpSection.tsx, ../employee-boardroom/calendarMeetings.ts
 *
 * @author DES
 * @date 20-10-2026
 */

import type { CalendarAttendee, CalendarMeeting } from "../employee-boardroom/calendarMeetings.ts";

/** Home shows the next few only; the Boardrooms page lists the rest. */
export const COMING_UP_MAX = 3;

/** Meetings still to come or running now, soonest first, at most `max`. */
export function comingUpMeetings(
  meetings: CalendarMeeting[],
  nowMs = Date.now(),
  max = COMING_UP_MAX,
): CalendarMeeting[] {
  return meetings
    .filter((m) => m.endMs > nowMs)
    .sort((a, b) => a.startMs - b.startMs)
    .slice(0, max);
}

/** "Ali Khan, Sara Malik +2"; empty when nobody else is invited. */
export function peopleLabel(attendees: CalendarAttendee[], shown = 2): string {
  if (attendees.length === 0) return "";
  const names = attendees.slice(0, shown).map((a) => a.name || a.email);
  const more = attendees.length - names.length;
  return more > 0 ? `${names.join(", ")} +${more}` : names.join(", ");
}
